var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('rect',{attrs:{"width":"24","height":"24","opacity":"0"}}),_c('path',{attrs:{"d":"M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }